// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"styles_statusBadge__21DlZ","dot":"styles_dot__2UYsX"};